module.exports = __webpack_public_path__ + "static/media/down.9a53f5eb.svg";